<div class="font-small-2 text-right w-100"
     *ngIf="hasRegularTax">
  <ng-container *ngIf="companyTaxDistribution == CompanyTaxDistribution.COMPANY; else fromEmployeeSalary">
    <span>{{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAX_FROM_COMPANY' | translate }}</span>
  </ng-container>
  <ng-template #fromEmployeeSalary>
    <ng-container *ngIf="companyTaxDistribution == CompanyTaxDistribution.EMPLOYEE_SALARY; else fromEmployeeBudget">
      <span>{{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAX_FROM_EMPLOYEE' | translate }}</span>
    </ng-container>
    <ng-template #fromEmployeeBudget>
      <ng-container
        *ngIf="(companyTaxDistribution == CompanyTaxDistribution.EMPLOYEE &&
        (benefitDetails?.benefitType != BenefitType.Transport && benefitDetails?.benefitType != BenefitType.ProfessionalDevelopment)); else elseBlock">
        <span>{{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAX_FROM_BUDGET' | translate }}</span>
      </ng-container>
      <ng-template #elseBlock>
        <span>{{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAX_FROM_GENERAL_BUDGET' | translate }}</span>
      </ng-template>
    </ng-template>
  </ng-template>
</div>

<div class="font-small-2 text-right w-100" *ngIf="hasCamTax">
  <span>
    {{ benefitDetails.camTax | number: '1.2-2' }} {{ 'DETAILS.UNIT1' | translate }}
    {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.CAM_WITHHELD_FROM_BENEFITS_BUDGET' | translate }}
  </span>
</div>
